import ActionsForm from '@/shared/mixins/actionsForm'
import templateTable from './components/templateTable/templateTable.vue'
import templateFilter from '../TemplateFilter/templateFilter.vue'
import panelTemplate from '../detailsTemplate/panelTemplate/panelTemplate.vue'
import tabsTemplate from '../detailsTemplate/tabsTemplate/tabsTemplate.vue'

// import Tools from '@/components/tools/Tools.js'

export default {
  name: 'templateQmaLV',
  components: {templateTable, templateFilter, panelTemplate, tabsTemplate},
  mixins: [ActionsForm],
  data () {
    return {
      details: false,
      TipoQmaTemplate: 'LV',
      templateid: null,
      tipoTemplate: null
    }
  },
  mounted () {
  },
  methods: {
    search (data) {
      this.$refs.tablelv.formSearch = data
      this.$refs.tablelv.onLoad()
    },
    atualizaPainel () {
      this.$refs.painel.onLoad()
    },
    templateQMADetalhes (value) {
      this.details = true
      this.templateid = value.id
      this.tipoTemplate = value.tipoTemplate
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/templateQmaLV/templateQmaLV.js